import { SectionShell } from "@/components/design-system/SectionShell";
import { CopyField } from "@/components/ui/copy-field";

const code = `import { CopyField } from "@/components/ui/copy-field"

<CopyField value="FW1.k3y-3x4mpl3.sig" ariaLabel="Copy license key" />

// Constrain width with a wrapper or className
<CopyField value="https://account.flywrite.app/buy?ldt=founders" className="max-w-xl" />`;

export function CopyFieldSection() {
  return (
    <SectionShell
      id="copy-field"
      title="Copy field"
      description={
        <>
          A read-only, monospace value with a one-click copy-to-clipboard
          button. Shows a check mark for two seconds after copying. Long
          values scroll horizontally inside the field instead of wrapping.
        </>
      }
      whenToUse={
        <ul>
          <li>License keys, API tokens, and other machine-readable strings the user needs to paste elsewhere.</li>
          <li>Shareable URLs (checkout links, invite links).</li>
          <li>Identifiers that must be copied exactly (Stripe ids, machine ids).</li>
        </ul>
      }
      whenNotToUse={
        <ul>
          <li>Editable values — use an Input from the Forms primitives.</li>
          <li>Prose or multi-line content — this is a single-line field.</li>
          <li>Inline code mentions in body copy — use a bare <code>&lt;code&gt;</code> element.</li>
        </ul>
      }
      preview={
        <div className="flex max-w-xl flex-col gap-4">
          <CopyField value="FW1.k3y-3x4mpl3-v4lu3.sig" ariaLabel="Copy license key" />
          <CopyField
            value="https://account.flywrite.app/buy?ldt=founders"
            ariaLabel="Copy checkout URL"
          />
        </div>
      }
      code={code}
      options={
        <ul className="list-disc pl-5">
          <li>
            <code>value</code> — the string shown and copied. Required.
          </li>
          <li>
            <code>ariaLabel</code> — accessible label for the copy button;
            defaults to “Copy to clipboard”. Set it to name the value (e.g.
            “Copy license key”).
          </li>
          <li>
            <code>className</code> — merged onto the wrapper; use it to
            constrain width (<code>max-w-xl</code>) or add margins.
          </li>
          <li>
            If the clipboard API is unavailable, copying no-ops and the value
            stays selectable for manual copying.
          </li>
        </ul>
      }
    />
  );
}
